import { useEffect, useState } from 'react'
// TODO: replace to global hooks
export const useClientWidth = (): number => {
  const [clientWidth, setClientWidth] = useState(0)

  useEffect(() => {
    const updateClientWidth = () => {
      setClientWidth(window.innerWidth)
    }

    setClientWidth(window.innerWidth)

    window.addEventListener('resize', updateClientWidth)
    return () => window.removeEventListener('resize', updateClientWidth)
  }, [])

  return clientWidth
}
